import { useLocation, useOutletContext } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react';
import { GeneralButton } from '../components/GeneralButton';
import useRedirectToErrorPage from './errors/hooks/redirectToErrorPage';
import axios from "axios";

const SigningTextComponents = [
  <SignContractComponent />,
  <ContractSignedComponent />
]

export const ContractSigningPanel = () => {
  const location = useLocation();
  const [currentComponent, setCurrentComponent] = useState(0);
  const [contractUrl, setContractUrl] = useState(
    location.state?.contractUrl ?? ""
  );
  const [isPollingActive, setIsPollingActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  useRedirectToErrorPage(errorMessage);
  const clientCode = useOutletContext();

  const checkSignedContracts = useCallback(async () => {
    if (clientCode === '') {
      return;
    }
    try {
      const response = await axios.get(
        `https://app.deb00.it/api/contract/get-link-to-sign/${encodeURIComponent(clientCode)}`
      );

      if (response.data["status"] !== "success") {
        throw new Error(
          "Si è verificato un errore. Non è possibile effettuare la procedura, contattare l'assistenza."
        );
      }

      const signingData = response.data["data"];
      const isSigned = String(signingData["contratto_firmato"])
        .toLowerCase() === "si";

      if (!isSigned) {
        if (!signingData["url_firma_contratto"]) {
          throw new Error(
            "Il link per la firma non è disponibile. Contattare l'assistenza."
          );
        }

        setCurrentComponent(0);
        setContractUrl(signingData["url_firma_contratto"]);
      }
      else {
        setIsPollingActive(false);
        setCurrentComponent(1);
        setContractUrl("");
      }
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message ||
          error.message ||
          "Si è verificato un errore durante la generazione del piano rateale."
      );
    }
  }, [clientCode]);

  useEffect(() => {
    checkSignedContracts();
  }, [checkSignedContracts]);

  useEffect(() => {
    if (isPollingActive === true) {
      const intervalId = setInterval(() => {
        checkSignedContracts();
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [checkSignedContracts, clientCode, isPollingActive]);

  function onButtonClick() {
    if (isContractUrlNull()) {
      return;
    }

    window.open(contractUrl, "_blank", "noreferrer");
    setIsPollingActive(true);
  }

  const isContractUrlNull = () => contractUrl == null || contractUrl === "";

  return (
    <div className="flex flex-col items-center">
      <div className="w-10/12 lg:w-4/12 flex flex-col items-center">

        <div className="h-4" />
        {SigningTextComponents[currentComponent]}
        {currentComponent === 0 ? (
          <>
            <div className="h-8" />
            <GeneralButton disabled={isContractUrlNull()} buttonText={"FIRMA"} onClick={onButtonClick} />
          </>
        ) : null}
      </div>
    </div>
  )
}

function SignContractComponent() {
  return (
    <>
      <h1 className="text-2xl font-bold text-green-600">PROCEDIAMO ALLA FIRMA DEGLI ACCORDI</h1>
      <div className="h-8" />
      <ol className="list-decimal font-bold text-xl">
        <li>CONTRATTO</li>
        <li>PROFORMA</li>
        <li>DELEGA</li>
      </ol>
      <div className="h-8" />
      <p className="text-lg text-left">
        <span className="font-bold">FAI ATTENZIONE</span>, ora sarai reindirizzato su
        <span className="font-bold"> YOUSIGN</span> per la firma del contratto.
      </p>
      <div className="h-8" />
      <p className="text-lg text-left">
        Successivamente alla firma prenderemo in carico la documentazione e sarà
        ricontattato quanto prima dal nostro ufficio amministrativo!
      </p>
    </>
  )

}

function ContractSignedComponent() {
  return (
    <>
      <h1 className="text-2xl font-bold text-green-600">FIRMA COMPLETATA</h1>
      <div className="h-8" />
      <p className="text-lg text-left">
        Perfetto, hai terminato il processo di firma! Puoi chiudere questa pagina.
      </p>
      <div className="h-8" />
      <p className="text-lg text-left font-bold">
        Sarai ricontattato nelle prossime ore dall'ufficio pre-legale per presa appuntamento
        telefonico e per iniziare l'istruttoria. <br /> Grazie!
      </p>
    </>)
}
